import rockWall from 'game/sprites/images/rock-wall.png';

export const RockWallSprite = <image href={rockWall} />;
